module.exports = __webpack_public_path__ + "static/media/icn-file.5677e471.svg";